import React from 'react';
import PropTypes from 'prop-types';

import { useFormContext } from 'react-hook-form';
import { useTranslation, Trans } from 'react-i18next';
import { generateStyle } from '../helpers/styles';
import regexPatterns from '../constants/regexPatterns';

/**
* Renders user address
* 
* @param {Object}   props
* @param {string}   props.label        - The upper label
* @param {number}   props.width        - Max width inside the container
* @param {boolean}  props.loading      - Flag to show/hide component loader
* @param {Object}   props.validation   - Validation Object
* @param {Function} props.onClick      - OnClick event handler
* @param {string}   props.street       - User street name
* @param {string}   props.neighborhood - User neighborhood
* @param {string}   props.city         - User city name
* @param {string}   props.state        - User state
* @param {string}   props.zipcode      - User zipcode
*/
const AddressInput = ({ label, width, loading, validation, onClick, street, neighborhood, city, state, zipcode }) => {
  const { t } = useTranslation('addressInput');
  const { register, setValue, errors, triggerValidation } = useFormContext();

  const name = 'address';
  const isTouched = street || neighborhood || city || state || zipcode;
  const isValidAddress = street && neighborhood && city && state;
  const classes = generateStyle('input', width, isTouched, errors[name]);
  const isLoaded = !loading;
  const isValidZipcode = regexPatterns.zipcode.test(zipcode);

  let addressData = '';
  if (isValidAddress) {
    addressData = JSON.stringify({ street, neighborhood, city, state });
  }
  setValue(name, addressData);
  addressData && triggerValidation(name);

  let textKey = 'found';
  if (!addressData) {
    textKey = (isValidZipcode && isLoaded) ? 'notFound' : 'noInput';
  }
  return (
    <div className={classes}>
      <span className='input__label'>{label}</span>
      <div className='input__grouper'>
        <div className='input__element input__element--fake'>
          <Trans t={t} i18nKey={`${textKey}.description`} values={{ street, neighborhood, city, state }} />
        </div>
        <button type='button' className='input__editor' onClick={onClick}>
          <Trans t={t} i18nKey={`${textKey}.button`} />
        </button>
      </div>
      {errors[name] && <span className='input__error'>{errors[name].message}</span>}
      <input type='hidden' name={name} ref={register(validation)} />
    </div>
  );
}
AddressInput.propTypes = {
  label: PropTypes.string,
  width: PropTypes.number,
  loading: PropTypes.bool,
  validation: PropTypes.object,
  onClick: PropTypes.func,
  street: PropTypes.string,
  neighborhood: PropTypes.string,
  city: PropTypes.string,
  state: PropTypes.string
};
export default AddressInput;